import { useContext, useEffect, useMemo } from "react";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import { LoadingContext } from "../../shared/providers/loading/loading.provider";
import { useResources } from "../../shared/hooks/useResources";
import { DEFAULT_LANGUAGE } from "../../shared/constants";
import { markdownToHtml } from "../../shared/helpers/utils";
import { useParams } from "react-router-dom";

function ResourcesDescription() {

    const param = useParams();

    const { setIsLoading } = useContext(LoadingContext);
    const { translate, lang } = useContext(TranslationContext);
    const {
        isLoading,
        data
    } = useResources(lang ?? DEFAULT_LANGUAGE, param.country);

    const description = useMemo(() => data?.data.description ?? "", [data]);

    useEffect(() => {
        setIsLoading(isLoading);
    }, [isLoading]);


    return (
        <div className="container-fluid gx-2 pt-2 pb-5">
            <div className="resources">
                <h1 className="text-h3-md mb-1">
                    {translate(
                        "common.national_resources_services",
                        "National Resources and Services"
                    )}
                </h1>
                {!!description &&
                    <div className="mb-12">
                        <div
                            className="rich_text text-bd1-rg color-neutrals-dark m-0"
                            dangerouslySetInnerHTML={{ __html: markdownToHtml(description) }}>
                        </div>
                    </div>
                }

            </div>
        </div>
    );
}

export default ResourcesDescription;
